import PageLogin from './components/Login';

export default PageLogin;


// WEBPACK FOOTER //
// ./routes/login/index.js